// Styles dédiés pour chaque type d'activité sur la page Activités
import styled from 'styled-components';

// ===============================
// CLUB DU MOIS DECATHLON
// ===============================
export const ClubDuMoisCard = styled.div`
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  }
`;
export const ClubDuMoisCardHeader = styled.div`
  background: #4a6bce;
  color: white;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  h3 { margin: 0; font-size: 1.5rem; }
  svg { font-size: 2rem; }
`;
export const ClubDuMoisCardBody = styled.div`
  padding: 20px;
  p { margin: 0 0 15px; color: #555; line-height: 1.6; }
`;

// ===============================
// TROPHEE INCLUS SPORT SUPER U
// ===============================
export const TropheeInclusSportCard = styled.div`
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  }
`;
export const TropheeInclusSportCardHeader = styled.div`
  background: #01a562;
  color: white;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  h3 { margin: 0; font-size: 1.5rem; }
  svg { font-size: 2rem; }
`;
export const TropheeInclusSportCardBody = styled.div`
  padding: 20px;
  p { margin: 0 0 15px; color: #555; line-height: 1.6; }
`;

// ===============================
// LABEL 5A
// ===============================
export const Label5ACard = styled.div`
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  height: 480px;
  width: 100%;
  max-width: 100%;
  min-width: 0; /* Empêche l'élargissement des colonnes grid */
  display: flex;
  flex-direction: column;
  cursor: pointer;
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  }
`;
export const Label5AImageContainer = styled.div`
  width: 100%;
  height: 200px;
  overflow: hidden;
  flex-shrink: 0;
  position: relative;
  background: #f8f9fa;
`;
export const Label5ACardBody = styled.div`
  padding: 25px;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;
export const Label5ACategory = styled.div`
  color: #6c757d;
  font-size: 0.70rem;
  font-weight: 600;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;
export const Label5ATitle = styled.h3`
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 12px;
  color: #132e57;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
  min-height: 56px;
`;
export const Label5AExcerpt = styled.p`
  font-size: 0.95rem;
  color: #6c757d;
  margin-bottom: auto;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  max-height: 4.5em;
  word-wrap: break-word;
  word-break: break-word;
  flex-grow: 1;
`;

export const Label5ASpecialCard = ({ title, excerpt, category, date, clubs, onClick }) => (
  <Label5ACard onClick={onClick}>
    <Label5AImageContainer>
      {/* Ici tu mets ton carrousel ou image */}
    </Label5AImageContainer>
    <Label5ACardBody>
      <Label5ACategory>{category}</Label5ACategory>
      <Label5ATitle>{title}</Label5ATitle>
      <Label5AExcerpt>{excerpt}</Label5AExcerpt>
    </Label5ACardBody>
  </Label5ACard>
);

// ===============================
// OSARC MAG
// ===============================
export const OsarcMagCard = styled.div`
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  }
`;
export const OsarcMagImage = styled.div`
  width: 100%;
  height: 140px;
  background: #f5f5f5;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;
export const OsarcMagContent = styled.div`
  padding: 20px;
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
export const OsarcMagTitle = styled.h3`
  font-size: 1.2rem;
  color: #132e57;
  margin: 0 0 12px 0;
  font-weight: 700;
  line-height: 1.3;
`;
export const OsarcMagDate = styled.div`
  font-size: 0.9rem;
  color: #666;
  font-weight: 500;
  margin-top: auto;
`;

// ===============================
// FESTIVAL PICANTIN
// ===============================
export const FestivalPicantinCard = styled.div`
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  }
`;
export const FestivalPicantinCardHeader = styled.div`
  background: #e67e22;
  color: white;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  h3 { margin: 0; font-size: 1.5rem; }
  svg { font-size: 2rem; }
`;
export const FestivalPicantinCardBody = styled.div`
  padding: 20px;
  p { margin: 0 0 15px; color: #555; line-height: 1.6; }
`; 